import axiosDonation from "./axiosDonation";

const driverApi = {
  createDriver: (data: any) => {
    const url = "/serene/driver/create";
    return axiosDonation.post(url, data);
  },
  listDrivers: (partnerId: string) => {
    const url = `/serene/driver/list?partnerId=${partnerId}`;
    return axiosDonation.post(url, null);
  },
  updateDriver: (data: any) => {
    const url = "/serene/driver/update";
    return axiosDonation.post(url, data);
  },
  updateStatus: (data: { id: string; status: string }) => {
    const url = "/serene/driver/update-status";
    return axiosDonation.post(url, data);
  },
  deleteDriver: (id: string) => {
    const url = `/serene/driver/delete?id=${id}`;
    return axiosDonation.post(url, { id });
  },
  getDriver: (id: string) => {
    const url = `/serene/driver/get?id=${id}`;
    return axiosDonation.get(url);
  },
  loginDriver: (data: { phone: string; password: string }) => {
    const url = "/serene/driver/login";
    return axiosDonation.post(url, data);
  },
};

export default driverApi;
